export function authHeaders() {
    const config = window.OMA_CONFIG || {};
    const headers = {
        Accept: 'application/json',
    };

    if (config.data_token && config.data_ts) {
        headers['X-Md-Token'] = config.data_token;
        headers['X-Md-Ts'] = String(config.data_ts);
    }

    return headers;
}
